import type { ShowBundleWithContent, TvShowBundleInfo } from '@setplex/tria-api'
import type { TFunction } from 'i18next'
import type { AdjustPurchaseableFn } from '~/features/payment/sse-purchases'
import type { ShowWithPrice } from '~/shared/interfaces'
import type { UiShowBundleWithContent, UiTvShowBundleInfo } from './index.h'

import {
  extendMediaItemByLabelPrice,
  getLabelPriceForPurchasedItem,
} from '~/shared/tools'

export const formatBundleWithContent = (
  bundle: ShowBundleWithContent | null,
  adjustShow: AdjustPurchaseableFn,
  adjustSet: AdjustPurchaseableFn,
  t: TFunction
): UiShowBundleWithContent | null => {
  if (!bundle) return null

  const adjustedBundle = adjustSet(bundle)
  const { purchaseInfo, shows } = adjustedBundle

  const rentedDuration = getLabelPriceForPurchasedItem({ purchaseInfo })
  const labelRented = rentedDuration
    ? t('rented_to', {
        duration: rentedDuration,
      })
    : ''

  const showsFormatted = adjustedBundle.purchaseInfo
    ? shows
    : shows.map(
        (show) =>
          extendMediaItemByLabelPrice(adjustShow(show), true) as ShowWithPrice
      )

  return {
    ...adjustedBundle,
    shows: showsFormatted,
    labelRented,
  }
}

export const formatBundleRowWithContent =
  (t: TFunction, adjust: AdjustPurchaseableFn) =>
  (bundle: TvShowBundleInfo): UiTvShowBundleInfo => {
    bundle = adjust(bundle)
    const { labelPrice, rented } = extendMediaItemByLabelPrice(bundle)
    return {
      ...bundle,
      quantityText: t('series_amount', {
        amount: bundle.contentQuantity,
      }),
      labelPrice,
      rented,
      link: `/content/series/bundles/${bundle.id}`,
    }
  }
